<template>
  <div>

    <v-card>
      <v-card-text class="pb-4">

        <div class="d-flex justify-space-between align-center">

          <div class="d-flex justify-start align-center">

            <div class="mr-2 tableFilter"><DateSelect v-model="filterAdded" label="Added" range :disabled="filtersLoading" :loading="filtersLoading"/></div>
            <div class="mr-2 tableFilter"><DateSelect v-model="filterSold" label="Sold" range :disabled="filtersLoading" :loading="filtersLoading"/></div>

            <div class="mr-2 tableFilter">
              <v-select multiple v-model="filterKind" label="Product Kind" :items="getFilterItemsByType('kind')" :disabled="filtersLoading" :loading="filtersLoading" dense outlined hide-details />
            </div>

            <div class="mr-2 tableFilter">
              <v-select multiple v-model="filterSource" label="Source" :items="getFilterItemsByType('source')" :disabled="filtersLoading" :loading="filtersLoading" dense outlined hide-details />
            </div>

            <div class="mr-2 tableFilter">
              <v-select multiple v-model="filterStatus" label="Status" :items="getFilterItemsByType('status')" :disabled="filtersLoading" :loading="filtersLoading" dense outlined hide-details />
            </div>

            <div><v-switch v-model="filterHideCompleted" label="Hide Completed" :disabled="filtersLoading" :loading="filtersLoading" /></div>

          </div>

          <div class="d-flex justify-start">
            <div><v-btn color="secondary" class="mr-2" dense small @click="selectAllForCPL">SELECT ALL</v-btn></div>

            <template v-if="getSelectedCplLeads.length>0">
              <div><v-btn color="secondary" class="darken-1 mr-2" dense small @click="deselectAllForCPL">DESELECT ALL</v-btn></div>
            </template>

            <div><v-btn color="primary" :disabled="getSelectedCplLeads.length===0" dense small @click="setCPLDialogOpen=true;">SET CPL</v-btn></div>
          </div>

        </div>

        <v-data-table :loading="getCplLeadsLoading" :headers="headers" :items="getCplLeads" class="body--text" disable-pagination hide-default-footer>

          <template v-slot:item.id="{ item }"><a :href="`/leads/${item.id}/`" target="_blank">{{ item.id | customPlaceholder }}</a></template>
          <template v-slot:item.added="{ item }">{{ item.added | formatCustomDate('YYYY-MM-DD') | customPlaceholder }}</template>
          <template v-slot:item.source="{ item }">{{ item.source | customPlaceholder }}</template>
          <template v-slot:item.sales_person="{ item }">{{ item.sales_person | customPlaceholder }}</template>
          <template v-slot:item.lead_metadata="{ item }">{{ item.lead_metadata | customPlaceholder }}</template>
          <template v-slot:item.sold="{ item }">{{ item.sold | formatCustomDate('YYYY-MM-DD') | customPlaceholder }}</template>
          <template v-slot:item.links="{ item }"><span v-html="product_links(item.product)"/></template>
          <template v-slot:item.status="{ item }">{{ item.status | customPlaceholder }}</template>
          <template v-slot:item.cpl="{ item }">{{ item.cpl | formatCurrency }}</template>

          <template v-slot:item.selected="{ item }">
            <v-checkbox v-model="item.selected" color="primary" />
          </template>

        </v-data-table>

        <template v-if="getNumberOfCplLeads>50">
          <v-divider class="mb-4" />
          <div class="text-caption font-weight-bold">{{getNumberOfCplLeads}} results found, showing the first 50. Please use the filters to narrow your search</div>
        </template>

      </v-card-text>
    </v-card>

    <SetCPLDialog v-model="setCPLDialogOpen" />

  </div>
</template>

<script>

  import { mapGetters,mapActions } from 'vuex';
  import DateSelect from '@/components/Globals/DateSelect.vue';
  import SetCPLDialog from './SetCPLDialog';

  export default {

    components: { DateSelect,SetCPLDialog },

    data() {
      return {

        setCPLDialogOpen: false,

        headers: [
          { text: 'Sale Lead', align: 'start', sortable: true, value: 'id'},
          { text: 'Added', sortable: true, value: 'added' },
          { text: 'Source', sortable: true, value: 'source' },
          { text: 'Sales Person', sortable: true, value: 'sales_person' },
          { text: 'Lead Metadata', sortable: true, value: 'lead_metadata' },
          { text: 'Sold', sortable: true, value: 'sold' },
          { text: 'Links', sortable: true, value: 'links' },
          { text: 'Status', sortable: true, value: 'status' },
          { text: 'CPL', sortable: true, value: 'cpl' },
          { text: '', sortable: false, value: 'selected' },
        ],

      }
    },

    computed: {
      ...mapGetters('cpl',['getNumberOfCplLeads','getCplLeads','getSelectedCplLeads','getCplLeadsLoading','getFilterItemsByType','getFilterByType','getStatusesLoading','getSourcesLoading']),

      filtersLoading(){
        return this.getStatusesLoading || this.getSourcesLoading;
      },

      filterKind: {
        get() { return this.getFilterByType('kind'); },
        set(val) { this.setFilterFetchLead({key:'kind',value:val}); }
      },

      filterSource: {
        get() { return this.getFilterByType('source'); },
        set(val) { this.setFilterFetchLead({key:'source',value:val}); }
      },

      filterStatus: {
        get() { return this.getFilterByType('status'); },
        set(val) { this.setFilterFetchLead({key:'status',value:val}); }
      },

      filterAdded: {
        get() { return this.getFilterByType('added'); },
        set(val) { this.setFilterFetchLead({key:'added',value:val}); }
      },

      filterSold: {
        get() { return this.getFilterByType('sold'); },
        set(val) { this.setFilterFetchLead({key:'sold',value:val}); }
      },

      filterHideCompleted: {
        get() { return this.getFilterByType('hideCompleted'); },
        set(val) { this.setFilterFetchLead({key:'hideCompleted',value:val}); }
      },

    },

    methods: {
      ...mapActions('cpl',['setFilterFetchLead','selectAllForCPL','deselectAllForCPL']),

      product_links(product){
        if(!product || !product.product_links){ return '-'; }
        const product_id = product.id;
        return product.product_links.map(e=>{
          const pid = (product_id===e.product_1)?e.product_2:e.product_1;
          const bundle = (e.link_type === "BUNDLE") ? "(Bundle)" : "";
          return `<a href="/leads/${pid}" target="_blank">${pid}</a>${bundle}`;
        }).join('<br/>');
      },

    },

  }
</script>

<style lang="scss" scoped>

  .tableFilter { max-width: 220px; }

</style>
